<template>
  <div class="m-15">
    <b-card
      header="Total de Páginas do Jornalzinho de Ofertas"
      align="center"
      bg-variant="secundary"
    >
      <b-row align-h="center">
        <b-col xl="2" lg="2" md="2" sm="2">
          <b-input-group size="md">
            <b-input
              type="text"
              id="filterInput"
              placeholder="Total de Páginas"
              v-model="paginas"
              disabled
            ></b-input>
            <b-input-group-append>
              <b-button @click="decrement()">-</b-button>
              <b-button @click="increment()">+</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col
        class="mb-4"
        xl="3"
        lg="3"
        md="3"
        sm="3"
        v-for="(prefillImage, index) in ImagemJornal"
        :key="index"
      >
        <picture-input
          :ref="pictureInputName(index)"
          :zIndex="10"
          :crop="false"
          :removable="true"
          style="max-width: 80%; max-height: 80%;"
          accept="image/*"
          size="10"
          button-class="changeBtn"
          removeButtonClass="removeBtn"
          :custom-strings="{
            upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
            tap: `${index + 1}<br>Clique aqui para <br> selecionar uma imagem`,
            drag: `${index + 1}<br>Arraste uma imagem <br> (ou clique aqui)`,
            change: 'Mudar foto',
            remove: 'Remover foto',
          }"
          :prefill="prefillImage"
          @change="onChange(index)"
          @remove="onRemove(index)"
        ></picture-input>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";
import store from "../../../store";

export default {
  name: "imagemjornalzinho",
  components: {
    PictureInput,
  },
  data: () => {
    return {
      id: "",
      selecionado: 2,
      paginas: 1,
      store,
      ImagemJornal: [],
    };
  },
  methods: {
    increment() {
      this.paginas++;
      this.ImagemJornal.push("");
      sessionStorage.setItem("qtdePaginas", this.paginas);
    },

    decrement() {
      if (this.paginas > 1) {
        this.paginas--;
        this.ImagemJornal.pop();
        sessionStorage.setItem("qtdePaginas", this.paginas);
      }
    },

    pictureInputName(page) {
      return `pictureInput${page}`;
    },

    onChange(index) {
      var arr = Object.values(this.$refs);

      var image = arr[index][0].image;

      const imageName = `image-${index + 1}`;

      if (typeof this.store.imagemJornal[index] != "undefined") {
        this.store.alteraImagem(index, imageName, image);
      } else this.store.adicionaImagem(imageName, image);

      if (index == 0) {
        if (image) this.$emit("can-continue", { value: true });
        else this.$emit("can-continue", { value: false });
      }
    },

    onRemove(index) {
      this.store.removeImagem(index);
      if (index == 0) {
        this.$emit("can-continue", { value: false });
      }
    },

    searchPages() {
      this.paginas = this.store.listaImagem().length;

      sessionStorage.setItem("qtdePaginas", this.paginas);

      this.ImagemJornal = [];
      for (let i = 0; i < this.store.listaImagem().length; i++) {
        const e = this.store.listaImagem()[i].imagem
          ? this.store.listaImagem()[i].imagem
          : null;
        this.ImagemJornal.push(e);
      }
    },
  },

  beforeMount() {
    store.limpaStore();
    this.ImagemJornal = [];
    this.searchPages();

    if (this.ImagemJornal) this.$emit("can-continue", { value: true });
    else this.$emit("can-continue", { value: false });
  },
};
</script>
